import { Helmet } from "react-helmet";
import {
  Box,
  ClickAwayListener,
  Stack,
  MenuItem,
  MenuList,
  Divider,
  InputAdornment,
  TextField,
  Select,
  Container,
  Grid,
  Typography,
  Button,
  usePagination,
  Grow,
  Popper,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper,
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled } from "@mui/styles";
import { useTranslation } from "react-i18next";
import cssVariables from "../../../../theme/cssVariables";
import * as Util from "../../../../services/global.service";

import Search from "@mui/icons-material/Search";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as FilterStatus } from "../../../../assets/icons/filter-status.svg";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";

import ResultDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/MessageDialog";
import CreateDialog from "../../../../components/adminConfigWorkflow/CreateDialog";
import CustomPagination from "../../../../components/CustomPagination";

import { getWorkflowList, postCheckUsedCode, deleteWorkflow } from "../../../../actions/admin/workflow";

const useStyles = makeStyles({
  plusSvg: {
    "& > path": {
      fill: "#fff",
      stroke: "#fff",
    },
  },
  draggingListItem: {
    background: "rgb(235,235,235)",
  },
  toggleBtnRoot: {
    background: `transparent !important`,
    color: "#6B6B6B !important",
    width: "320px",
    border: "none !important",
  },
  toggleBtnSelected: {
    background: `${cssVariables.color.primary}!important`,
    color: "#fff!important",
  },
  flexPaper: {
    flex: 1,
    minWidth: 350,
    "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
    "border-radius": "10px !important        ",
  },
  tab: {
    fontSize: "16px !important",
    fontWeight: "300 !important",
    // color: "#A3A3A3 !important",
    "&.Mui-selected": {
      color: cssVariables.color.primary + " !important",
    },
  },
  root: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
  },
});
const styles = {
  link: {
    color: "#5DA196",
    cursor: "pointer",
  },
  end: {
    color: "#A3A3A3",
  },
};

const WorkflowMain = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dataList, setDataList] = React.useState([]);
  const [filteredDataList, setFilteredDataList] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [search, setSearchValue] = React.useState("");
  const [itemDel, setItemDel] = React.useState("");
  const [perPage, setPerPage] = React.useState(10);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPage, setTotalPage] = React.useState(1);
  const anchorRef = React.useRef(null);
  const [active, setActive] = React.useState(true);
  const [notActive, setNotActive] = React.useState(false);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = React.useState(false);
  const [isCodeCheckDialogOpen, setIsCodeCheckDialogOpen] = React.useState(false);
  const [isCodeUsed, setIsCodeUsed] = React.useState(false);

  const goTo = (route, data) => {
    if (data) {
      navigate("/admin" + route, { replace: false, state: data });
    } else {
      navigate("/admin" + route, { replace: false });
    }
  }

  let fetchData = () => {
    dispatch(getWorkflowList()).then(resp => {
      if (resp?.workflows) {
        setDataList(resp?.workflows)
      }
    })
  }

  const handleOpenCreateDialog = () => {
    setIsCodeUsed(false)
    setIsCreateDialogOpen(true)
  }

  const handleGoNext = (data) => {
    dispatch(postCheckUsedCode(data.code)).then(resp => {
      if (!resp?.used) {
        goTo("/workflow/create", data)
        setIsCodeUsed(false)
      } else if (resp?.used) {
        // setIsCodeCheckDialogOpen(true)
        setIsCodeUsed(true)
      }
    })
  }

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const filterActiveSearch = (data) => {
    let result = [];
    let dataFilter = JSON.parse(JSON.stringify(data));
    if (notActive === false && active === false) {
      setFilteredDataList(result);
    } else if (notActive === true && active === true) {
      setFilteredDataList(data);
    } else {
      if (notActive === true) {
        let resultData = dataFilter.filter((rs) => rs?.status === "inactive");
        result = resultData;
        setFilteredDataList(result);
      } else if (active === true) {
        let resultData = dataFilter.filter((rs) => rs?.status === "active");
        result = resultData;
        setFilteredDataList(result);
      }
    }
  };

  const EditNotActive = (data) => {
    if (data === "notActive") {
      setNotActive(!notActive);
    } else if (data === "active") {
      setActive(!active);
    } else if (data === "selectAll") {
      if (notActive === true && active === true) {
        setNotActive(false);
        setActive(false);
      } else if (notActive === false && active === false) {
        setNotActive(true);
        setActive(true);
      } else if (notActive === true || active === true) {
        setNotActive(true);
        setActive(true);
      }
    }
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  }
  const handleSearch = (event) => {
    setSearchValue(event.target.value);
  }
  // table data
  const currentData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * perPage;
    const lastPageIndex = firstPageIndex + perPage;
    return filteredDataList.slice(firstPageIndex, lastPageIndex);
  }, [filteredDataList, currentPage, perPage]);

  const handleTotalPage = () => {
    const List = filteredDataList;
    const totalPage =
      Math.ceil(List.length / perPage) === 0
        ? 1
        : Math.ceil(List.length / perPage);
    setTotalPage(totalPage);
  };

  const doSearch = (data) => {
    let result = [];
    let dataSearch = JSON.parse(
      JSON.stringify(
        data !== undefined && data !== null ? data : dataList
      )
    );
    if (
      search !== "" &&
      dataSearch !== undefined &&
      dataSearch.length > 0
    ) {
      let resultData = dataSearch.filter((rs) => {
        return Object.keys(rs).some((key) => {
          if (key === "name" || key === "code") {
            return (
              rs[key]
                .toString()
                .toLowerCase()
                .indexOf(search.toString().toLowerCase()) !== -1
            );
          }
        });
      });
      result = resultData;
    } else {
      result = dataSearch;
    }
    filterActiveSearch(result);
  };

  const handlePerPageChange = (event) => {
    setPerPage(event.target.value);
  };
  const handleSetCurrentPage = (value) => {
    const getSelectedPage = value.filter(
      (item) => item.type === "page" && item.selected
    );
    setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1);
  };

  let sortData = (key, direction) => {
    let result = [...filteredDataList]
    result = result.sort(function (b, a) {
      if (direction) {
        if (a[key] > b[key]) {
          return -1;
        } else {
          return 1;
        }
      } else {
        if (a[key] < b[key]) {
          return -1;
        } else {
          return 1;
        }
      }
    })
    setFilteredDataList(result)
  }

  const onScroll = (evt) => {
    if (evt !== undefined && evt !== null) {
      if (open) {
        setOpen(false);
      }
    }
  }

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }))
  const [isSuccessDeleteDialogOpen, setIsSuccessDeleteDialogOpen] =
    React.useState(false)
  const [isConfirmDeleteDialogOpen, setIsConfirmDeleteDialogOpen] =
    React.useState(false)
  const handleConfirmDeleteDialog = (val, serial) => {
    setIsConfirmDeleteDialogOpen(val);
  }
  const handleConfirmDeleteList = () => {
    dispatch(deleteWorkflow(itemDel)).then(() => {
      setIsConfirmDeleteDialogOpen(false, setIsSuccessDeleteDialogOpen(true))
      fetchData()
    }).catch(() => {
      setIsConfirmDeleteDialogOpen(false)
      fetchData()
    })
  }

  const handleDeleteClick = React.useCallback((e, data) => {
    e.stopPropagation();
    e.preventDefault();
    setItemDel(data);
    handleConfirmDeleteDialog(true);
  }, []);

  const handleClickEditWorkflow = (row) => {
    goTo("/workflow/" + row.id, { type: row.type !== "" ? row.type : "probation" })
  }



  // useEffect here
  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    doSearch(dataList)
  }, [dataList]);

  useEffect(() => {
    handleTotalPage();

  }, [currentData]);

  useEffect(() => {
    doSearch();
  }, [search, notActive, active]);
  // end useEffect

  const columnsWidth = [
    "calc(10% - 12px)",
    "calc(30% - 12px)",
    "calc(16% - 12px)",
    "calc(10% - 12px)",
    "calc(17% - 12px)",
    "calc(17% - 12px)",
    "60px"
  ]

  return (
    <Box
      onScroll={onScroll}
      sx={{ maxHeight: "100%", overflowY: "auto" }}
    >
      <Helmet>
        <title>Admin - Workflow | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.end}>{t("adminWorkflow.label.title")}</span>
            </Typography>
          </Grid>
          <Grid container item>
            <Grid item>
              <Typography
                color="#404349"
                fontSize={36}
                fontWeight="600"
              >
                {t("adminWorkflow.label.title")}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid container item>
              <Box sx={{ width: "100%" }}>
                <Box
                  pb="30px"
                  pt="30px"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <TextField
                    id="input-with-icon-textfield"
                    fullWidth
                    placeholder={t("adminWorkflow.label.search")}
                    size="small"
                    sx={{
                      background: "#fff",
                      width: "400px",
                      input: { padding: "11px 14px 11px 0px" },
                      ".MuiOutlinedInput-root": { color: "#404349" },
                    }}
                    className="searchTextField-h40"
                    value={search}
                    onChange={handleSearch}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search style={{ color: "#C4C4C4" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => handleOpenCreateDialog()}
                    color="primary"
                    variant="contained"
                    sx={{
                      width: "129px",
                      height: "45px",
                      p: "0",
                      textTransform: "none"
                    }}
                  >
                    <PlusIcon className={classes.plusSvg} />
                    <Typography
                      ml={1}
                      fontWeight="500"
                      fontSize={18}
                      lineHeight="26.91px"
                    >
                      {t("adminWorkflow.label.create")}
                    </Typography>
                  </Button>
                </Box>
              </Box>
              <div className={classes.root}>
                <Paper className={classes.flexPaper}>
                  <Box px="40px">
                    <Box
                      px="25px"
                      py="19px"
                      sx={{ display: "flex", flexDirection: "row" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[0],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("adminWorkflow.label.code")}
                        </Typography>
                        <Typography
                          component="span"
                          style={{
                            flexDirection: "column",
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronExpandUp
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("code", true)}
                          />
                          <ChevronExpandDown
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("code", false)}
                          />
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[1],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("adminWorkflow.label.name")}
                        </Typography>
                        <Typography
                          component="span"
                          style={{
                            flexDirection: "column",
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronExpandUp
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("name", true)}
                          />
                          <ChevronExpandDown
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("name", false)}
                          />
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[2],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("adminWorkflow.label.type")}
                        </Typography>
                        <Typography
                          component="span"
                          style={{
                            flexDirection: "column",
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronExpandUp
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("type", true)}
                          />
                          <ChevronExpandDown
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("type", false)}
                          />
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[3],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("adminWorkflow.label.status")}
                        </Typography>
                        <Stack direction="row" spacing={2}>
                          <div>
                            <FilterStatus
                              ref={anchorRef}
                              id="composition-button"
                              style={{ cursor: "pointer" }}
                              onClick={handleToggle}
                            />
                            <Popper
                              open={open}
                              anchorEl={anchorRef.current}
                              role={undefined}
                              placement="bottom-start"
                              transition
                              disablePortal
                              style={{ "z-index": "1" }}
                            >
                              {({ TransitionProps, placement }) => (
                                <Grow
                                  {...TransitionProps}
                                  style={{
                                    transformOrigin:
                                      placement === "bottom-start"
                                        ? "left top"
                                        : "left bottom",
                                  }}
                                >
                                  <Paper
                                    sx={{ "margin-top": "5px !important" }}
                                  >
                                    <ClickAwayListener
                                      onClickAway={handleClose}
                                    >
                                      <MenuList
                                        autoFocusItem={open}
                                        id="composition-menu"
                                        aria-labelledby="composition-button"
                                        onKeyDown={handleListKeyDown}
                                      >
                                        <Box px="16px" py="6px">
                                          <FormGroup>
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  indeterminate={
                                                    notActive !== active
                                                  }
                                                  onChange={(e) =>
                                                    EditNotActive("selectAll")
                                                  }
                                                  checked={
                                                    notActive === true &&
                                                      active === true
                                                      ? true
                                                      : false
                                                  }
                                                />
                                              }
                                              label={t("competency.selectAll")}
                                            />
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  onChange={(e) =>
                                                    EditNotActive("notActive")
                                                  }
                                                  checked={notActive}
                                                />
                                              }
                                              label={t("admin.label.inactive")}
                                            />
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  onChange={(e) =>
                                                    EditNotActive("active")
                                                  }
                                                  checked={active}
                                                />
                                              }
                                              label={t("admin.label.active")}
                                            />
                                          </FormGroup>
                                        </Box>
                                      </MenuList>
                                    </ClickAwayListener>
                                  </Paper>
                                </Grow>
                              )}
                            </Popper>
                          </div>
                        </Stack>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[4],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("adminWorkflow.label.createdBy")}
                        </Typography>
                        <Typography
                          component="span"
                          style={{
                            flexDirection: "column",
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronExpandUp
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("created_at", true)}
                          />
                          <ChevronExpandDown
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("created_at", false)}
                          />
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[5],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("adminWorkflow.label.updatedBy")}
                        </Typography>
                        <Typography
                          component="span"
                          style={{
                            flexDirection: "column",
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronExpandUp
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("updated_at", true)}
                          />
                          <ChevronExpandDown
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("updated_at", false)}
                          />
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[6],
                        }}
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {t("adminWorkflow.label.action")}
                        </Typography>
                      </Box>
                    </Box>
                    <Divider width="100%" />
                  </Box>
                  {/* table data */}
                  {currentData &&
                    currentData.length > 0 ? (
                    currentData.map((row, index) => (
                      <Box px="40px" key={row.id}>
                        <Box
                          sx={{
                            width: "100%",
                            position: "relative",
                            "&:before": {
                              content: '""',
                              position: "absolute",
                              height:
                                row?.status === "inactive" ? "100%" : "0px",
                              width:
                                row?.status === "inactive" ? "100%" : "0px",
                              top: "0",
                              background: "#FAFAFA",
                              opacity: "0.7",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              height: "96px",
                              background: "#FFF",
                              width: "100%",
                              display: "flex",
                              "align-items": "center",
                            }}
                            px="25px"
                          >
                            <Box sx={{ width: columnsWidth[0] }} pr="15px">
                              <Typography
                                fontSize={16}
                                color="#404349"
                                lineHeight="23.96px"
                                fontWeight="400"
                                sx={{
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {row?.code}
                              </Typography>
                            </Box>
                            <Box sx={{ width: columnsWidth[1] }} pr="15px">
                              <Typography
                                fontWeight="500"
                                fontSize={18}
                                lineHeight="23.92px"
                                sx={{
                                  color: "#404349",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {row?.name}
                              </Typography>
                            </Box>
                            <Box sx={{ width: columnsWidth[2] }} pr="15px">
                              <Typography
                                fontWeight="500"
                                fontSize={18}
                                lineHeight="23.92px"
                                sx={{
                                  color: "#404349",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {row?.type !== "" ? row.type : "Probation"}
                              </Typography>
                            </Box>
                            <Box sx={{ width: columnsWidth[3] }} pr="15px">
                              <Typography
                                fontWeight="400"
                                fontSize={16}
                                lineHeight="23.92px"
                                sx={{
                                  color: "#5DA196",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {row?.status === "active"
                                  ? "ACTIVE"
                                  : "INACTIVE"}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: columnsWidth[4],
                              }}
                              pr="15px"
                            >
                              <Typography
                                fontWeight="400"
                                fontSize={16}
                                lineHeight="24px"
                                sx={{
                                  color: "#404349",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {/* {row?.created_by} */}
                                {row?.created_by !== undefined && row?.created_by !== null && row?.created_by !== "" ? row?.created_by : row?.created_at !== undefined && row?.created_at !== null && row?.created_at !== "" ? "Default" : ""}
                              </Typography>
                              <Typography
                                fontWeight="400"
                                fontSize={14}
                                lineHeight="21px"
                                sx={{
                                  color: "#A3A3A3",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {Util.dateDayTimeFormatAdmin(row?.created_at)}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: columnsWidth[5],
                              }}
                              pr="15px"
                            >
                              <Typography
                                fontWeight="400"
                                fontSize={16}
                                lineHeight="24px"
                                sx={{
                                  color: "#404349",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {/* {row?.updated_by} */}
                                {row?.updated_by !== undefined && row?.updated_by !== null && row?.updated_by !== "" ? row?.updated_by : row?.updated_at !== undefined && row?.updated_at !== null && row?.updated_at !== "" ? "Default" : ""}
                              </Typography>
                              <Typography
                                fontWeight="400"
                                fontSize={14}
                                lineHeight="21px"
                                sx={{
                                  color: "#A3A3A3",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {Util.dateDayTimeFormatAdmin(row?.updated_at)}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                width: columnsWidth[6],
                                justifyContent: "flex-end",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  width: "100px",
                                  "z-index": "1",
                                }}
                              >
                                <Box pr="20px">
                                  <BootstrapTooltip
                                    title={`Edit`}
                                    placement="top"
                                  >
                                    <EditIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        handleClickEditWorkflow(row || "")
                                      }}
                                    />
                                  </BootstrapTooltip>
                                </Box>
                                {row?.status === "active" ? (
                                  <Box>
                                    <DeleteIcon
                                      style={{
                                        opacity: "0.2",
                                        cursor: "no-drop",
                                        pointerEvents: "none",
                                      }}
                                    />
                                  </Box>
                                ) : !row?.allow_delete && row?.status === "inactive" ? (
                                  <Box>
                                    <DeleteIcon
                                      style={{
                                        opacity: "0.2",
                                        cursor: "no-drop",
                                        pointerEvents: "none",
                                      }}
                                    />
                                  </Box>
                                ) : (
                                  <Box>
                                    <BootstrapTooltip
                                      title={`Delete`}
                                      placement="top"
                                    >
                                      <DeleteIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={(e) => {
                                          handleDeleteClick(e, row?.id);
                                        }}
                                      />
                                    </BootstrapTooltip>
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                        <Divider width="100%" />
                      </Box>
                    ))
                  ) : (
                    <Box
                      sx={{
                        pt: "50px",
                        textAlign: "center",
                        pb: "500px",
                      }}
                    >
                      <Nodata />
                      <Typography
                        color="#A0A0A0"
                        fontWeight="500"
                        fontSize={20}
                        lineHeight="30px"
                      >
                        {t("label.noData")}
                      </Typography>
                    </Box>
                  )}
                </Paper>
              </div>
            </Grid>
          </Grid>
          <Grid container mt={1} spacing={2}>
            <Grid item xs sm md display="flex" alignItems="center">
              <Box mr={1}>
                <Typography variant="s14_fw400">
                  {t("label.showMaxItems")}
                </Typography>
              </Box>
              <Select
                id="pagination"
                variant="outlined"
                defaultValue={10}
                value={perPage}
                onChange={handlePerPageChange}
                displayEmpty
                size="small"
                className="white-bg"
              >
                <MenuItem value={10}>
                  <Typography style={{ fontWeight: "300" }}>10</Typography>
                </MenuItem>
                <MenuItem value={20}>
                  <Typography style={{ fontWeight: "300" }}>20</Typography>
                </MenuItem>
                <MenuItem value={30}>
                  <Typography style={{ fontWeight: "300" }}>30</Typography>
                </MenuItem>
              </Select>
            </Grid>
            <Grid item display="flex" alignItems="center" ml="auto">
              <Typography variant="s14_fw400">
                {t("label.page")} {currentPage} {t("label.of")} {totalPage}
              </Typography>
            </Grid>
            <Grid item ml="auto" display="flex" alignItems="center">
              <CustomPagination
                setCurrentPage={handleSetCurrentPage}
                selected={currentPage}
                count={totalPage}
              ></CustomPagination>
            </Grid>
          </Grid>
          <ResultDialog
            open={isSuccessDeleteDialogOpen}
            setValue={setIsSuccessDeleteDialogOpen}
            text={t("admin.label.workflowDeletedSuccessfully")}
          />
          <ConfirmDialog
            open={isConfirmDeleteDialogOpen}
            trash={true}
            doConfirm={handleConfirmDeleteList}
            setValue={handleConfirmDeleteDialog}
            title={t("label.confirmationofDeletion")}
            text={t("admin.label.workflowConfirmDelete")}
          />
          {/* create dialog */}
          <CreateDialog
            open={isCreateDialogOpen}
            setValue={setIsCreateDialogOpen}
            goNext={handleGoNext}
            isCodeUsed={isCodeUsed}
          />
        </Container>
        <MessageDialog
          open={isCodeCheckDialogOpen}
          setValue={setIsCodeCheckDialogOpen}
          type="fail"
          title={t('adminWorkflow.dialog.codeUsedTitle')}
          text={t('adminWorkflow.dialog.codeUsedDesc')}
        />
      </Box>
    </Box>
  );
};
export default WorkflowMain;
